<section>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <h1>Evaluation Style List</h1>
      </div>
      <div class="col text-right">
        <button (click)="openAddEditModel(addevalution)" class="btn btn-info">Add Evaluation Style</button>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <div class="card">
          <div class="example-container mat-elevation-z8">
            <mat-table [dataSource]="dataSource" matSort>
              <ng-container matColumnDef="sno">
                <mat-header-cell *matHeaderCellDef mat-sort-header> S.No. </mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index"> {{ i + 1 }} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="image">
                <mat-header-cell *matHeaderCellDef> Image</mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <img [src]="row.image" alt="image not found" class="img2" (click)="onImageClick(modalimage, row.image)">
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Style Name </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.title| titlecase }} </mat-cell>
              </ng-container>
  <ng-container matColumnDef="description">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Style Description  </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.content |titlecase}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="edit">
                <mat-header-cell *matHeaderCellDef> Edit Style </mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <button class="btn btn-sm btn-outline-primary"
                    (click)="openAddEditModel(addevalution,row)">Edit Style</button>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="delete">
                <mat-header-cell *matHeaderCellDef> Delete Style</mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <button class="btn btn-sm btn-outline-danger"
                    (click)="DeleteEvalutionCategory(row.id)">Delete Style</button>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="view">
                <mat-header-cell *matHeaderCellDef> View Evaluation</mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <button class="btn btn-sm btn-outline-danger" (click)="viewEvaluation(row.id)"> View Evaluation ({{row.count}})</button>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>

            <div *ngIf="dataSource?.data?.length === 0" class="m-3">No data found</div>

            <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Modal Template -->
<ng-template #addevalution let-modal>
  <div class="modal-header">
    <h4 class="modal-evalutioncategory">{{ editItem ? 'Edit' : 'Add' }} Evaluation Style</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')">
      <span>&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="evalutioncategoryform">
      <div class="form-group">
        <label>Evaluation Style</label>
        <input maxlength="100" formControlName="title" type="text" class="form-control" />
        <div
          *ngIf="evalutioncategoryform.controls['title'].errors && (!evalutioncategoryform.controls['title'].pristine || submitted  )"
          class="error-msg">
          <div class="text-danger" *ngIf="evalutioncategoryform.controls['title'].hasError('required')">
            Evalution style is required.
          </div>
          <div class="text-danger" *ngIf="evalutioncategoryform.controls['title'].hasError('maxlength')">
            Evalution style cannot exceed 100 characters.
          </div>
          <div class="text-danger" *ngIf="evalutioncategoryform.controls['title'].hasError('minlength')">
            Evalution style must be at least 2 characters long.
          </div>
        </div>
      </div>
 <div class="form-group">
        <label>Evaluation Style description</label>
        <input maxlength="500" formControlName="content" type="text" class="form-control" />
        <div
          *ngIf="evalutioncategoryform.controls['content'].errors && (!evalutioncategoryform.controls['content'].pristine || submitted  )"
          class="error-msg">
          <div class="text-danger" *ngIf="evalutioncategoryform.controls['content'].hasError('required')">
            Evalution style description is required.
          </div>
          <div class="text-danger" *ngIf="evalutioncategoryform.controls['content'].hasError('maxlength')">
            Evalution style  description cannot exceed 500characters.
          </div>
          <div class="text-danger" *ngIf="evalutioncategoryform.controls['content'].hasError('minlength')">
            Evalution style  description must be at least 2 characters long.
          </div>
        </div>
      </div>
      <!-- <div class="form-group">
        <label>Image</label>
        <input type="file" (change)="onFileChange($event)" class="form-control" />
        <div
          *ngIf="evalutioncategoryform.controls['image'].errors && (!evalutioncategoryform.controls['image'].pristine || submitted  )"
          class="error-msg">
          <div class="text-danger" *ngIf="evalutioncategoryform.controls['image'].hasError('required')">
            Image is required.
          </div>
        </div>
      </div> 
       <div *ngIf="isEdit">
        <img [src]="editItem.image" alt="" style="max-width: 28%;margin-left: 20px;">
      </div> -->
      <!-- <div class="col-md-12 form-group mb-3"> -->
         <div class="form-group">
          <label> Image</label>
          <input type="file" class="form-control  form-control-rounded image input" (change)="onFileChange($event)"
            id="fileInput" />

          <div *ngIf="imageSelected">
            <div class="row mb-3">
              <div class="col-lg-4">
                <img id="imageToCrop" style="max-width: 100%; margin-top: 20px;" *ngIf="imageSelected" />
              </div>
              <div class="col-lg-4 text-left" *ngIf="imageSelected">
                <button (click)="cropImage()" class="btn1 btn btn-primary"
                  style="margin-top: 20px;margin-left: 50px;">Crop Image</button>
              </div>
              <div class="col-lg-4">
                <div class="cropper-wrapper" *ngIf="croppedImage">
                  <p class="mb-1 mt-3 text-center"><b>Cropped Image</b></p>
                  <div class="profile-picture">
                    <img class="croped_round_image" [src]="croppedImage" (error)="onImageError($event)"
                      alt="Profile Picture" />
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div *ngIf="evalutioncategoryform.controls['image'].hasError('required')" class="text-danger">
            Image is required
          </div>
          <div *ngIf="evalutioncategoryform.controls['image'].hasError('maxSize')" class="text-danger">
         Image size must be 5 MB or less
          </div>
        </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="AddOrEditEvalutionCategory()">Save</button>
  </div>
</ng-template>
<ng-template #modalimage let-modal>
  <div class="p-3">
    <img [src]="modalImageUrl" alt="Full Image" style="width: 100%; max-height: 90vh; object-fit: contain;">
  </div>
</ng-template>





 <!-- <div class="col-md-12 form-group mb-3">
          <label> Image</label>
          <input type="file" class="form-control form-control-rounded image" (change)="onFileChange($event)"
            id="fileInput" />

          <div *ngIf="imageSelected">
            <div class="row mb-3">
              <div class="col-lg-4">
                <img id="imageToCrop" style="max-width: 100%; margin-top: 20px;" *ngIf="imageSelected" />
              </div>
              <div class="col-lg-4 text-left" *ngIf="imageSelected">
                <button (click)="cropImage()" class="btn1 btn btn-primary"
                  style="margin-top: 20px;margin-left: 50px;">Crop Image</button>
              </div>
              <div class="col-lg-4">
                <div class="cropper-wrapper" *ngIf="croppedImage">
                  <p class="mb-1 mt-3 text-center"><b>Cropped Image</b></p>
                  <div class="profile-picture">
                    <img class="croped_round_image" [src]="croppedImage" (error)="onImageError($event)"
                      alt="Profile Picture" />
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div *ngIf="submitted && !imgdata" class="text-danger">
            Image is required
          </div>
        </div> -->